import Modal from 'components/Modal';

import PanelActionFooter from 'pages/MaintenancePage/components/PanelActionFooter';
import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import useEditDraft from './hooks/useEditDraft';

import EditServiceForm from './components/EditServiceForm';
import {
    FOOTER_CANCEL_BUTTON_TEST_ID,
    FOOTER_SAVE_BUTTON_TEST_ID,
    FOOTER_TEST_ID,
    TEST_ID
} from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const EditServiceRecordPanel: FunctionComponent<Props> = ({
    className = '',
    isOpen,
    onClose,
    onSave,
    record,
    testId = TEST_ID
}) => {
    const t = useTranslation();
    const editDraft = useEditDraft({ isOpen, record });

    if (!record) {
        return null;
    }

    const handleSave = () => {
        const edit = editDraft.buildEdit();

        if (!edit) {
            return;
        }

        onSave({ edit });
    };

    const footer = (
        <PanelActionFooter
            cancelTestId={FOOTER_CANCEL_BUTTON_TEST_ID}
            cancelText={t.EDIT_SERVICE_CANCEL}
            isPrimaryDisabled={!editDraft.isDraftValid}
            onCancel={onClose}
            onPrimary={handleSave}
            primaryTestId={FOOTER_SAVE_BUTTON_TEST_ID}
            primaryText={t.EDIT_SERVICE_SAVE}
            testId={FOOTER_TEST_ID}
        />
    );

    return (
        <Modal
            className={`${styles.editServiceRecordPanel} ${className}`}
            footer={footer}
            isOpen={isOpen}
            onClose={onClose}
            overlayClassName={styles.editServiceOverlay}
            testId={testId}
            title={t.EDIT_SERVICE_TITLE}>
            <EditServiceForm
                draft={editDraft.draft}
                onAddPhotos={editDraft.handleAddPhotos}
                onChangeNotes={editDraft.handleChangeNotes}
                onChangePartSerialNumber={editDraft.handleChangePartSerialNumber}
                onChangePerformedAt={editDraft.handleChangePerformedAt}
                onRemovePhoto={editDraft.handleRemovePhoto}
                record={record}
            />
        </Modal>
    );
};

export default EditServiceRecordPanel;
